import { Layout, Server, Database, Sparkles, Wrench, type LucideIcon } from "lucide-react";
import Section, { SectionHeading } from "../ui/Section";
import { useApp } from "../../context/AppContext";
import { skillGroups } from "../../data/content";

const iconMap: Record<string, LucideIcon> = {
  Layout,
  Server,
  Database,
  Sparkles,
  Wrench,
};

export default function Skills() {
  const { t, locale } = useApp();

  return (
    <Section id="skills" className="surface">
      <SectionHeading tag={t("skills.tag")} title={t("skills.title")} subtitle={t("skills.subtitle")} />
      <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {skillGroups.map((group) => {
          const Icon = iconMap[group.icon] ?? Sparkles;
          return (
            <div
              key={group.id}
              className="rounded-3xl border border-soft card-bg p-6 transition-all duration-300 hover:-translate-y-1 hover:border-cyan-400/40"
            >
              <div className="mb-4 flex items-center gap-3">
                <span className="grid h-10 w-10 place-items-center rounded-xl bg-gradient-to-br from-cyan-400/20 to-purple-500/20 text-cyan-300">
                  <Icon className="h-5 w-5" strokeWidth={1.8} />
                </span>
                <h3 className="font-display text-lg font-bold">{group.title[locale]}</h3>
              </div>
              <div className="flex flex-wrap gap-2">
                {group.skills.map((s) => (
                  <span
                    key={s}
                    className="rounded-lg border border-soft px-2.5 py-1 text-xs font-medium text-soft transition-colors hover:border-cyan-400/40 hover:text-cyan-400"
                  >
                    {s}
                  </span>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </Section>
  );
}
